import {getField, updateField} from 'vuex-map-fields';
import DEFINES from '@/defines';
import router from '@/router';
import * as API from '@/api';

function initialState () {
  return {
    list: [],
    chatRoom: null,
  };
}

const state = initialState ();

// actions

const actions = {
    /**
     * get Chatroom Registered Members
     */
    async listMembers(context, payload) {
        var response = await API.chatRoom.listMembers(payload);
        return response;
    },
    /**
     * update Chatroom Registered Member
     */
    async updateMember(context, payload) {
        var response = await API.chatRoom.updateMember(payload);
        return response;
    },
}

// getters
const getters = {
    getField,
}

const mutations = {
    updateField,
    reset (state) {
        // acquire initial state
        const s = initialState ();
        Object.keys (s).forEach (key => {
            state[key] = s[key];
        });
    },
}

export default {
    namespaced: true,
    state,
    actions,
    getters,
    mutations,
};
  